import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SpreadsheetGuide from "@/pages/spreadsheet-guide/page";
import ArticlePage from "@/pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/spreadsheet-guide",
    element: <SpreadsheetGuide />,
  },
  {
    path: "/article/:slug",
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;